import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IForcePasswordUpdateParams {
  systemUserIds?: string[];
}

export interface IForcePasswordUpdateResult extends IResult {
}

export class ForcePasswordUpdateRequest extends Request<IForcePasswordUpdateParams, IForcePasswordUpdateResult> {
  constructor(params: IForcePasswordUpdateParams) {
    super('forcePasswordUpdate', params);
  }
}
